import './PackageStateTag.scss';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { PACKAGE_STATES, PackageStateString } from '@/model/Logistic/PackageStates';

interface PackageStateTagProps {
  packageStatus: PACKAGE_STATES;
}

const PackageStateTag = (props: PackageStateTagProps) => {
  const { t } = useTranslation();
  const { packageStatus } = props;

  return (
    <Tag className={`PackageStateTag ${PACKAGE_STATES[packageStatus]}`}>
      {t(PackageStateString[packageStatus])}
    </Tag>
  );
};

export default PackageStateTag;
